import EmployeeRolesView from 'components/organisms/employee-roles/EmployeeRolesView'
import React from 'react'

const EmployeeRoles = () => {
    return (
        <EmployeeRolesView />
    )
}

export default EmployeeRoles